import React, { useContext } from 'react';
import { Button, Form, Input, Row, Col } from 'antd';
import { post_client_risk_form } from 'services/apiSrv';
import { useMutation } from 'react-query';
import { ModalContext } from 'context/ModalContext';
import { show_toast } from "utils/helpers";

function Add_Client_Risk(props) {
  const { modalClose } = useContext(ModalContext);
  const [form] = Form.useForm();

  const postClientRiskForm = useMutation(post_client_risk_form, {
    onSuccess: (data) => {
      form.resetFields();
      modalClose();
      props.onRiskAdded(); // Trigger refresh of risks list
      show_toast("Risk added successfully", "success");
    },
    onError: (error) => {
      modalClose();
      show_toast(`Error adding risk: ${error.message}`, "error");
    },
  });

  const validateMessages = {
    required: '${label} is required!',
  };

  const onFinish = async (values) => {
    try {
      await postClientRiskForm.mutateAsync({
        // client_id: props.clientId, // Assuming clientId is passed via props
        client_quotation_id: props.client_quotation_id,
        riskForm: values,
      });
    } catch (error) {
      console.error('Form submission error:', error);
    }
  };

  return (
    <div>
      <Form
        form={form}
        name="assetForm"
        onFinish={onFinish}
        layout="vertical"
        validateMessages={validateMessages}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Registration Number"
              name="registration_number"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Asset Value"
              name="sum_assured"
              rules={[
                { required: true },
                {
                  pattern: /^\d+(\.\d{1,2})?$/,
                  message: 'Please enter a valid number (up to 2 decimal places)',
                },
              ]}
            >
              <Input type="number" step="0.01" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={postClientRiskForm.isLoading}
            disabled={postClientRiskForm.isLoading}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}

export default Add_Client_Risk;